import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { FoodRequestScreen } from './FoodRequestScreen';

const route = getRouteApi('/food-requests/$requestId');

export function FoodRequestRoute() {
  const { requestId } = route.useParams();
  const navigate = useNavigate();

  const onOpen = useCallback(
    (id: string | null) => {
      if (id === null) void navigate({ to: '/food-requests' });
      else void navigate({ to: '/food-requests/$requestId', params: { requestId: id } });
    },
    [navigate],
  );

  /** A name request is reviewed in the queue's drawer; its own link lands there. */
  const onOpenName = useCallback(
    (id: string) => {
      void navigate({ to: '/food-requests', search: { open: id }, replace: true });
    },
    [navigate],
  );

  return <FoodRequestScreen requestId={requestId} onOpen={onOpen} onOpenName={onOpenName} />;
}
